import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { RouterSelectors } from '@elio/emanager-front/shared/data-access/router';
import { BACKEND_URL } from '@elio/shared/models';
import { Store } from '@ngrx/store';
import { first, mergeMap, Observable } from 'rxjs';

export class OfferInterceptor implements HttpInterceptor {
  private readonly OFFER_HTTP_HEADER = 'Elio-Offer';

  constructor(private store: Store) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.store.select(RouterSelectors.getOfferIdFromRouteParam).pipe(
      first(),
      mergeMap((offerId) => {
        let newRequest = request;
        if (offerId && request.url.includes(BACKEND_URL)) {
          newRequest = request.clone({
            setHeaders: { [this.OFFER_HTTP_HEADER]: String(offerId) },
          });
        }
        return next.handle(newRequest);
      })
    );
  }
}

export const OFFER_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: OfferInterceptor,
  multi: true,
  deps: [Store],
};
